import React from 'react';

const Terms = () => (
  <div style={{ padding: '2rem', fontFamily: 'Lato, sans-serif', maxWidth: '900px', margin: '0 auto' }}>
    <h1>Isadoran Creed — Terms of Service</h1>
    <p><em>Last updated: 2025-08-26</em></p>

    <h2>1. Overview</h2>
    <p>Isadoran Creed (“Service”) lets you connect your TikTok account and publish videos you create with our tools.</p>

    <h2>2. Accounts & Authorization</h2>
    <p>When you connect TikTok, you authorize us to request the minimum scopes needed to show your basic profile and publish content on your behalf. You can revoke access any time in TikTok.</p>

    <h2>3. Content</h2>
    <p>You are responsible for the content you upload and post. Do not upload content you don’t own or that violates laws or TikTok policies.</p>

    <h2>4. Acceptable Use</h2>
    <p>No illegal, infringing, deceptive, or harmful activity. We may suspend accounts that violate these terms.</p>

    <h2>5. Data & Privacy</h2>
    <p>See our Privacy Policy for what we collect and how we use it.</p>

    <h2>6. Disclaimers & Liability</h2>
    <p>Service is provided “as is.” To the extent permitted by law, we disclaim warranties and limit liability.</p>

    <h2>7. Changes</h2>
    <p>We may update these Terms. Continued use indicates acceptance.</p>

    <h2>8. Contact</h2>
    <p>contact@isadorancreed.com</p>
  </div>
);

export default Terms;


